export default {
	loading: 'Cargando...',
	add: 'Añadir',
	delete: 'Eliminar',
	edit: 'Modificar',
	query: 'Buscar',
	export: 'Exportar',
	handle: 'Operación',
	back: 'Volver',
	home: 'Inicio',
	confirm: 'Confirmar',
	cancel: 'Cancelar',
	clear: 'Limpiar',
	close: 'Cerrar',
	createTime: 'Hora de creación',
	updateTime: 'Hora de actualización',
	required: 'Los campos obligatorios no pueden estar vacíos',
	app: {
		title: 'Plataforma de gestión del ciclo de vida del dispositivo',
		description:
			'Una plataforma de administración de bajo umbral desarrollada con Vue3, TypeScript, Element Plus, Vue Router, Pinia, Axios, i18n y Vite.',
		logoText: 'Plataforma de gestión del ciclo de vida del dispositivo',
		miniLogoText: 'MAKU',
		username: 'Nombre de usuario',
		password: 'Contraseña',
		captcha: 'Captcha',
		mobileSignIn: 'Inicio de sesión móvil',
		mobile: 'Móvil',
		signIn: 'Iniciar sesión',
		signOut: 'Cerrar sesión',
		profile: 'Perfil',
		large: 'Grande',
		default: 'Predeterminado',
		small: 'Pequeño',
		close: 'Cerrar',
		closeOthers: 'Cerrar otros',
		closeAll: 'Cerrar todo'
	},
	settings: {
		title: 'Configuración de diseño',
		sidebarDark: 'Barra lateral oscura',
		sidebarLight: 'Barra lateral clara',
		navbarLight: 'Barra de navegación clara',
		navbarTheme: 'Barra de navegación con tema',
		layout: 'Cambiar diseño',
		vertical: 'Vertical',
		columns: 'Columnas',
		transverse: 'Transversal',
		interface: 'Configuración de interfaz',
		uniqueOpened: 'Abrir exclusivamente',
		dark: 'Activar modo oscuro',
		logo: 'Activar LOGO',
		breadcrumb: 'Activar breadcrumb',
		tabs: 'Activar pestañas',
		tabsCache: 'Activar caché de pestañas',
		tabsStyle: 'Estilo de pestañas',
		tips: 'Después de configurar, solo tendrá efecto temporalmente. Para que sea permanente, debe hacer clic en el botón "Copiar configuración" a continuación para reemplazar la configuración en store/theme/config.ts.',
		copyConfig: 'Copiar configuración',
		reset: 'Restablecer',
		copySuc: 'Copia exitosa',
		style1: 'Estilo-1',
		style2: 'Estilo-2',
		langSwitch: 'Idioma',
		alarmBroadcast: 'Difusión de Alertas',
		alarmQRCode: 'Código QR de Alerta',
		appDownload: 'Descargar APP',
		aiAssistant: 'Asistente IA',
		fullscreen: 'Pantalla completa/Salir de pantalla completa',
		exitFullscreen: 'Pantalla completa/Salir de pantalla completa'
	},
	common: {
		save: 'Guardar',
		reset: 'Restablecer',
		delete: 'Eliminar',
		edit: 'Editar',
		cancel: 'Cancelar',
		confirm: 'Confirmar',
		back: 'Volver'
	},
	profile: {
		title: 'Información personal',
		basicInfo: 'Información básica',
		basicData: 'Datos básicos',
		changePassword: 'Cambiar contraseña',
		uploadAvatar: 'Suba un avatar',
		platformLogo: 'Logo de la plataforma',
		uploadPlatformLogo: 'Suba el logo de la plataforma',
		username: 'Nombre de usuario',
		realName: 'Nombre',
		mobile: 'Número de móvil',
		email: 'Correo electrónico',
		orgName: 'Organización',
		postName: 'Puesto',
		createTime: 'Fecha de creación',
		encryptPassword: 'Contraseña cifrada',
		currentPassword: 'Contraseña actual',
		noData: 'Sin datos',
		authTitle: 'Por seguridad, introduzca su contraseña de inicio de sesión actual para ver la contraseña cifrada',
		authMessage: 'Verificación de identidad',
		passwordRequired: 'La contraseña no puede estar vacía',
		modifySuccess: 'Modificado correctamente',
		gender: 'Género',
		phonePlaceholder: 'Número de móvil',
		emailPlaceholder: 'Correo electrónico',
		namePlaceholder: 'Nombre',
		freeLogin: 'Inicio de sesión sin contraseña',
		freeLoginTip: 'El enlace contiene la contraseña de inicio de sesión cifrada; cualquiera que lo posea puede iniciar sesión directamente.',
		basicParams: 'Parámetros básicos',
		displayParams: 'Parámetros de visualización',
		baseUrl: 'Dirección del sistema',
		baseUrlPlaceholder: 'Por ejemplo: http://172.16.8.152:7018',
		baseUrlRequired: 'Introduzca la dirección del sistema',
		usernamePlaceholder: 'Introduzca el nombre de usuario',
		usernameRequired: 'Introduzca el nombre de usuario',
		loginPassword: 'Contraseña de inicio de sesión',
		loginPasswordPlaceholder: 'Introduzca la contraseña de inicio de sesión actual para generar la contraseña cifrada',
		loginPasswordRequired: 'Introduzca la contraseña de inicio de sesión',
		targetPage: 'Página de destino',
		targetPagePlaceholder: 'Por defecto /screen, puede introducir otra ruta de página',
		targetPageRequired: 'Introduzca la página de destino',
		showMenu: 'Mostrar menú',
		showMenuHint: 'Muestra el menú lateral y la navegación superior al abrir el enlace (show_menu=true)',
		showSettings: 'Mostrar configuración',
		showSettingsHint: 'Muestra el botón de configuración al abrir el enlace (show_settings=true)',
		hiddenTree: 'Ocultar árbol izquierdo',
		hiddenTreeHint: 'Oculta el árbol izquierdo de la página al abrir el enlace (is_hidden_true=true)',
		generateLink: 'Generar enlace',
		generateLinkSuccess: 'Enlace generado correctamente',
		generateLinkFailed: 'No se pudo generar el enlace, revise los parámetros',
		resetLink: 'Restablecer',
		generatedLink: 'Enlace generado',
		generatedLinkPlaceholder: 'Complete los parámetros y haga clic en «Generar enlace»',
		copyLink: 'Copiar enlace',
		copyLinkSuccess: 'Enlace copiado al portapapeles',
		copyLinkFailed: 'Error al copiar, seleccione y copie manualmente',
		openLink: 'Abrir enlace',
		qrcode: 'Código QR',
		scanTip: 'Escanee con una tablet o un móvil para abrirlo directamente',
		thirdParty: {
			title: 'Inicio de sesión de terceros',
			serialNumber: 'N.º',
			platformType: 'Tipo de plataforma',
			wechatWork: 'WeChat Work',
			dingtalk: 'DingTalk',
			feishu: 'Feishu',
			wechat: 'WeChat',
			nickname: 'Apodo',
			status: 'Estado',
			unbound: 'No vinculado',
			bound: 'Vinculado',
			bind: 'Vincular',
			unbind: 'Desvincular',
			operationSuccess: 'Operación exitosa'
		}
	},
	appDownload: {
		title: 'Descarga de APP móvil',
		qrcodeTip: 'Escanee el código QR para descargar la APP',
		manualTitle: 'Manual de operación',
		manualPreview: 'Manual de operación',
		viewManual: 'Ver manual de operación'
	},
	sys: {
		common: {
			batchDelete: 'Eliminar en lote',
			reset: 'Restablecer',
			platformType: 'Tipo de plataforma',
			groupName: 'Nombre del grupo',
			status: 'Estado',
			pleaseSelect: 'Por favor seleccione',
			parentNode: 'Nodo padre',
			pleaseSelectParent: 'Seleccione el padre',
			sort: 'Orden',
			operationSuccess: 'Operación exitosa',
			operationFailed: 'Operación fallida, inténtelo de nuevo'
		},
		attachment: {
			upload: 'Subir',
			batchDelete: 'Eliminar en lote',
			action: {
				download: 'Descargar',
				preview: 'Vista previa'
			},
			uploadFailed: 'Error al subir: ',
			uploadSuccess: 'Subida exitosa',
			fileTooLarge: 'El tamaño del archivo no puede superar 100M',
			query: {
				bizType: 'Tipo de negocio',
				name: 'Nombre del adjunto',
				fileType: 'Tipo de adjunto'
			},
			table: {
				name: 'Nombre del adjunto',
				fileType: 'Tipo de archivo',
				size: 'Tamaño',
				platform: 'Plataforma de almacenamiento',
				bizType: 'Tipo de negocio'
			}
		},
		config: {
			sms: {
				title: 'Configuración de SMS',
				signName: 'Firma SMS',
				templateId: 'Plantilla SMS',
				groupNameHint: 'Las configuraciones con el mismo grupo enviarán SMS en rotación',
				url: 'URL de acceso',
				urlHint: 'URL de acceso de la APP',
				senderIdIntlHint: 'Requerido para SMS internacional',
				channelNo: 'Nº de canal',
				channelNoHint: 'El Nº de canal es requerido'
			},
			mail: {
				title: 'Configuración de correo',
				groupNameHint: 'Las configuraciones con el mismo grupo enviarán correos en rotación',
				mailFrom: 'Cuenta de correo',
				mailFromPlaceholder: 'Correo del remitente',
				mailPass: 'Contraseña de correo',
				mailHost: 'Servidor SMTP',
				mailHostHint: 'Requerido para correo empresarial/propio',
				mailPort: 'Puerto SMTP',
				mailPortHint: 'Por defecto es el puerto 25',
				endpointHint: 'Endpoint de Aliyun'
			},
			third: {
				title: 'Inicio de sesión de terceros'
			}
		},
		maComponents: {
			pleaseSelect: 'Por favor seleccione',
			pleaseInput: 'Por favor ingrese',
			loading: 'Cargando datos...',
			noData: 'Sin datos',
			expandAll: 'Expandir todo',
			collapseAll: 'Colapsar todo',
			device: {
				selectDevice: 'Seleccione el dispositivo',
				deviceName: 'Nombre del dispositivo',
				deviceType: 'Tipo de dispositivo',
				deviceModel: 'Modelo del dispositivo'
			},
			dict: {
				selectDict: 'Seleccione el diccionario',
				dictType: 'Tipo de diccionario',
				dictValue: 'Valor del diccionario',
				dictLabel: 'Etiqueta del diccionario'
			},
			org: {
				selectOrg: 'Seleccione la organización',
				orgName: 'Nombre de la organización',
				parentOrg: 'Padre'
			},
			user: {
				selectUser: 'Seleccione el usuario',
				username: 'Nombre de usuario',
				realName: 'Nombre real',
				mobile: 'Número de teléfono móvil',
				createTime: 'Fecha de creación'
			},
			post: {
				selectPost: 'Seleccione el puesto',
				postName: 'Nombre del puesto'
			},
			report: {
				selectReport: 'Seleccione el reporte',
				reportName: 'Nombre del reporte'
			},
			address: {
				selectAddress: 'Seleccione la dirección de la organización',
				province: 'Provincia',
				city: 'Ciudad',
				district: 'Distrito municipal'
			},
			icon: {
				selectIcon: 'Seleccione el ícono',
				iconName: 'Nombre del ícono'
			}
		},
		menu: {
			expandAll: 'Expandir todo',
			collapseAll: 'Colapsar todo',
			table: {
				name: 'Nombre',
				icon: 'Icono',
				type: 'Tipo',
				openStyle: 'Modo de apertura',
				sort: 'Orden',
				route: 'Ruta',
				authority: 'Permiso'
			},
			type: {
				menu: 'Menú',
				button: 'Botón',
				api: 'API'
			},
			openStyle: {
				internal: 'Interno',
				external: 'Externo'
			},
			permissionButtonConfig: 'Configurar botones de permiso',
			addPermissionButtonsTitle: 'Añadir botones de permiso (CRUD)',
			submit: 'Enviar',
			operationSuccess: 'Operación exitosa',
			operationFailed: 'Operación fallida, inténtelo de nuevo',
			permission: {
				view: 'Ver',
				add: 'Añadir',
				edit: 'Modificar',
				delete: 'Eliminar'
			},
			form: {
				type: 'Tipo',
				name: 'Nombre',
				parent: 'Menú padre',
				route: 'Ruta',
				sort: 'Orden',
				openStyle: 'Modo de apertura',
				display: 'Mostrar',
				authority: 'Permiso',
				authorityPlaceholder: 'Separado por comas, p.ej. sys:menu:save,sys:menu:update',
				icon: 'Icono'
			},
			display: {
				show: 'Mostrar',
				hide: 'Ocultar'
			}
		},
		org: {
			table: {
				name: 'Nombre',
				path: 'Ruta'
			},
			form: {
				gridLayout: 'Diseño de cuadrícula',
				parentDept: 'Departamento padre',
				orgPlaceholder: 'Organización',
				name: 'Nombre',
				leader: 'Responsable'
			}
		},
		dict: {
			type: {
				query: {
					dictType: 'Tipo de diccionario',
					dictName: 'Nombre del diccionario'
				},
				table: {
					dictType: 'Tipo de diccionario',
					dictName: 'Nombre del diccionario',
					remark: 'Observación',
					source: 'Fuente'
				},
				source: {
					dictData: 'Datos de diccionario',
					dynamicSql: 'SQL dinámico'
				},
				action: {
					dictConfig: 'Configurar diccionario',
					dynamicData: 'Datos dinámicos'
				},
				drawer: {
					dictConfig: 'Configurar diccionario',
					dynamicData: 'Datos dinámicos'
				},
				form: {
					dictType: 'Tipo de diccionario',
					dictName: 'Nombre del diccionario',
					remark: 'Observación',
					source: 'Fuente',
					dictSql: 'SQL dinámico',
					dictSqlPlaceholder: 'p.ej. select id as dictValue, name as dictLabel from sys_role where deleted = 0'
				}
			},
			data: {
				table: {
					dictValue: 'Valor',
					dictLabel: 'Etiqueta'
				},
				form: {
					dictValue: 'Valor',
					dictLabel: 'Etiqueta',
					labelClass: 'Estilo de etiqueta',
					remark: 'Observación'
				}
			}
		},
		user: {
			import: 'Importar',
			exportFile: 'Exportar archivo',
			table: {
				username: 'Nombre de usuario',
				realName: 'Nombre',
				gender: 'Género',
				status: 'Estado',
				mobile: 'Móvil',
				orgName: 'Organización',
				accountExpireTime: 'Vencimiento de cuenta',
				passwordExpireTime: 'Vencimiento de contraseña'
			},
			query: {
				username: 'Nombre de usuario',
				mobile: 'Móvil',
				gender: 'Género',
				orgId: 'Organización'
			},
			form: {
				username: 'Nombre de usuario',
				realName: 'Nombre',
				gender: 'Género',
				email: 'Correo',
				wecomId: 'wecomId',
				mobile: 'Móvil',
				password: 'Contraseña',
				orgId: 'Organización',
				inspectOrgId: 'Organización (inspección)',
				roleIdList: 'Roles',
				postIdList: 'Puestos',
				wechatLevel: 'Nivel de alarma (WeChat)',
				wecomLevel: 'Nivel de alarma (WeCom)',
				wechatLevelPlaceholder: 'Nivel de alarma (Cuenta oficial de WeChat)',
				wecomLevelPlaceholder: 'Nivel de alarma (Cuenta oficial de WeCom)',
				smsLevel: 'Nivel de alarma (SMS)',
				mailLevel: 'Nivel de alarma (Correo)',
				tokenExpireTime: 'Vencimiento del token',
				tokenExpireTimePlaceholder: 'Seleccione el vencimiento del token',
				accountExpireTime: 'Vencimiento de cuenta',
				accountExpireTimePlaceholder: 'Seleccione el vencimiento de cuenta',
				passwordExpireTime: 'Vencimiento de contraseña',
				passwordExpireTimePlaceholder: 'Seleccione el vencimiento de contraseña',
				warnType: 'Tipo de alarma a enviar',
				generalWarnPushInterval: 'Intervalo de Envío de Alarma General',
				mediumWarnPushInterval: 'Intervalo de Envío de Alarma Media',
				pushIntervalUnitPlaceholder: 'Unidad: hora'
			},
			level: {
				normal: 'Normal',
				medium: 'Medio',
				severe: 'Severo',
				none: 'Ninguno'
			},
			validation: {
				mobileFormat: 'Por favor ingrese un móvil válido'
			}
		}
	},
	screen: {
		empty: {
			noData: 'Sin datos',
			noChart: 'Sin gráficos'
		},
		itemWrap: {
			loading: 'Cargando...'
		},
		common: {
			timeRange: {
				last7Days: 'Últimos 7 días',
				last1Month: 'Último mes',
				last3Months: 'Últimos 3 meses'
			},
			status: {
				running: 'Funcionamiento',
				stopped: 'Detenido',
				offline: 'Desconectado',
				unknown: 'Desconocido'
			},
			alarmLevel: {
				normal: 'Normal',
				general: 'General',
				medium: 'Medio',
				severe: 'Severo',
				emergency: 'Emergencia',
				generalAlarm: 'Alarma general',
				mediumAlarm: 'Alarma media',
				severeAlarm: 'Alarma severa'
			},
			device: {
				countUnit: 'unidad(es)',
				deviceCountWithUnit: 'Cantidad de dispositivos (unidades)',
				processPointCount: 'Puntos de proceso (unidades)',
				warnPointCount: 'Puntos de alarma (unidades)'
			}
		},
		index: {
			headerTitle: 'Plataforma de operación y mantenimiento inteligente',
			deviceHealthRank: 'Clasificación de salud de dispositivos',
			deviceTypeStats: 'Estadísticas de tipo de dispositivo',
			dailyRunStats: 'Estadísticas diarias de funcionamiento',
			deviceAlarmStats: 'Estadísticas de alarma de equipos',
			last7DaysAlarmHandle: 'Gestión de alertas últimos 7 días',
			last7DaysNewAlarm: 'Nuevas alertas últimos 7 días'
		},
		topc: {
			refreshTooltip: 'Actualizar datos de la página',
			profile: 'Centro personal',
			alarmQrcode: 'Código QR de alarma',
			appDownload: 'Descargar APP',
			logout: 'Cerrar sesión',
			bindPhoneRequired: 'El usuario debe vincular primero un número de móvil',
			warnQrcodeDialogTitle: 'Código QR de notificación de alarma'
		},
		contentCenter: {
			mapMode: 'Modo mapa',
			deviceMode: 'Modo dispositivo',
			mapConfig: 'Configuración de mapa',
			noDeviceData: 'Sin datos de dispositivos',
			pauseAutoPlay: 'Pausar reproducción automática',
			startAutoPlay: 'Iniciar reproducción automática',
			mapJson: 'JSON del mapa',
			uploadJson: 'Haga clic para cargar',
			mapPointInfo: 'Información de puntos del mapa',
			selectDept: 'Seleccionar departamento',
			pointName: 'Nombre del punto',
			pointNamePlaceholder: 'Ingrese el nombre del punto',
			longitude: 'Longitud',
			longitudePlaceholder: 'Ingrese la longitud',
			latitude: 'Latitud',
			latitudePlaceholder: 'Ingrese la latitud',
			addPoint: 'Añadir punto',
			cancel: 'Cancelar',
			saveConfig: 'Guardar configuración',
			saveSuccess: 'Configuración de mapa guardada exitosamente',
			saveFailed: 'Por favor verifique si el formulario está completado correctamente',
			runningStatusTitle: 'Estado de operación del dispositivo',
			columnIndex: 'Número',
			columnDeviceName: 'Nombre del dispositivo',
			columnDeviceNumber: 'Número del dispositivo',
			columnStatus: 'Estado de operación',
			columnDuration: 'Duración',
			columnAlarmLevel: 'Nivel de alarma',
			descriptionPrefix: 'Tipo de dispositivo: '
		},
		leftTop: {
			deviceCountSeriesName: 'Cantidad de dispositivos'
		},
		leftCenter: {
			totalLabel: 'Total',
			tooltipUnit: 'unidades',
			seriesName: 'Estadísticas de tipo de dispositivo'
		},
		leftBottom: {
			seriesRun: 'Funcionamiento',
			seriesStop: 'Detenido',
			seriesOffline: 'Desconectado'
		},
		rightTop: {
			levelSevere: 'Severo',
			levelMedium: 'Medio',
			levelGeneral: 'General',
			levelNormal: 'Normal',
			levelEmergency: 'Emergencia'
		},
		rightCenter: {
			handledAlarm: 'Alarmas procesadas',
			pendingAlarm: 'Alarmas pendientes'
		},
		rightBottom: {
			levelSevere: 'Severo',
			levelMedium: 'Medio',
			levelGeneral: 'General'
		},
		factoryDetails: {
			selectFactory: 'Seleccionar fábrica',
			totalAlarm: 'Total de alarmas',
			totalDevice: 'Total de dispositivos',
			totalSensor: 'Total de sensores',
			totalOrder: 'Total de órdenes',
			recentAlarm: 'Alarmas recientes',
			noAlarm: 'Sin alarmas',
			uploadFactoryImage: 'Cargar plano de fábrica',
			savePosition: 'Guardar posición',
			editPosition: 'Editar posición',
			dragTip: 'Arrastre el área de marcado para ajustar la posición',
			deviceCount: 'Cantidad de dispositivos',
			alarmCount: 'Cantidad de alarmas',
			orderCount: 'Cantidad de órdenes',
			saveSuccess: 'Guardado exitosamente',
			saveFailed: 'Error al guardar'
		},
		weather: {
			defaultWeather: 'Soleado'
		}
	},
	designForm: {
		widgetLibrary: 'Biblioteca de widgets',
		formDesign: 'Diseño de formulario',
		formConfig: 'Configuración del formulario',
		fieldSettings: 'Configuración de campos',
		add: 'Añadir',
		delete: 'Eliminar',
		copy: 'Copiar',
		moveUp: 'Subir',
		moveDown: 'Bajar',
		label: 'Etiqueta',
		placeholder: 'Marcador de posición',
		required: 'Obligatorio',
		defaultValue: 'Valor por defecto',
		hint: 'Ayuda',
		validation: 'Validación',
		width: 'Ancho',
		height: 'Alto',
		precision: 'Precisión',
		min: 'Mínimo',
		max: 'Máximo',
		format: 'Formato',
		multiple: 'Selección múltiple',
		clearable: 'Borrable',
		filterable: 'Buscable',
		options: 'Opciones',
		optionValue: 'Valor',
		optionLabel: 'Etiqueta',
		addOption: 'Añadir opción',
		save: 'Guardar',
		cancel: 'Cancelar',
		reset: 'Restablecer',
		preview: 'Vista previa',
		generateCode: 'Generar código',
		jsonEditor: 'Editor JSON',
		import: 'Importar',
		emptyWidget: 'Ningún widget seleccionado',
		fieldKey: 'Clave del campo',
		title: 'Título',
		staticData: 'Datos estáticos',
		varAssign: 'Vinculación de variable',
		dictData: 'Diccionario de datos',
		setOptionValue: 'Establecer valor de opción',
		varName: 'Nombre de la variable',
		dictKey: 'Clave del diccionario',
		buttonStyle: 'Estilo de botón',
		opProps: 'Propiedades de operación',
		readonly: 'Solo lectura',
		disabled: 'Deshabilitado',
		clear: 'Borrable',
		hideLabel: 'Ocultar etiqueta',
		showPassword: 'Mostrar contraseña',
		showWordLimit: 'Mostrar límite de palabras',
		validate: 'Validación',
		customError: 'Mensaje de error personalizado',
		string: 'Cadena',
		url: 'Dirección URL',
		email: 'Correo electrónico',
		pattern: 'Expresión regular',
		patternPlaceholder: 'Introduzca una expresión regular',
		designerTitle: 'MAKU - Diseñador de formularios',
		importJson: 'Importar JSON',
		generateJson: 'Generar JSON',
		clickUpload: 'Haga clic para cargar',
		dragTip: 'Arrastre desde la izquierda para añadir un campo',
		widgetTypes: {
			input: 'Cuadro de texto',
			textarea: 'Área de texto',
			number: 'Entrada numérica',
			select: 'Selector',
			radio: 'Botón de opción',
			checkbox: 'Casilla de verificación',
			switch: 'Interruptor',
			date: 'Selector de fecha',
			time: 'Selector de hora',
			rating: 'Calificación',
			slider: 'Deslizador',
			editor: 'Editor de texto enriquecido',
			upload: 'Carga',
			cascader: 'Selector en cascada',
			treeSelect: 'Selector de árbol',
			divider: 'Separador',
			text: 'Texto'
		}
	},
	charts: {
		loading: 'Cargando gráfico...',
		noData: 'Sin datos',
		export: 'Exportar',
		refresh: 'Actualizar',
		fullscreen: 'Pantalla completa',
		settings: 'Configuración',
		dataZoom: 'Zoom de datos',
		restore: 'Restaurar',
		peakCount: {
			title: 'Estadísticas de picos',
			index: 'Índice',
			frequency: 'Frecuencia (Hz)',
			amplitude: 'Amplitud'
		}
	},
	framework: {
		common: {
			tip: 'Aviso',
			operationSuccess: 'Operación exitosa',
			operationFailed: 'Operación fallida',
			all: 'Todo',
			detail: 'Detalle',
			ignore: 'Ignorar',
			setting: 'Configuración'
		},
		notifications: {
			unread: 'Mensajes no leídos',
			unreadInfo: 'Mensajes no leídos',
			initiator: 'Iniciador',
			content: 'Contenido',
			confirmIgnore: '¿Confirma que desea ignorar esta operación?',
			source: 'Origen: ',
			time: 'Hora: '
		},
		tenant: {
			title: 'Cambiar de inquilino',
			tenantId: 'ID del inquilino',
			tenantName: 'Nombre del inquilino',
			status: 'Estado',
			query: 'Buscar',
			pleaseSelect: 'Seleccione el inquilino al que desea cambiar'
		},
		theme: {
			light: 'Tema claro',
			dark: 'Tema oscuro',
			blue: 'Tema azul',
			blueX: 'Tema azul X',
			sidebarDeepBlue: 'Barra lateral azul marino',
			navbarDeepBlue: 'Barra superior azul marino'
		},
		navbar: {
			menuSearch: 'Buscar menú'
		},
		loginTimeout: {
			message: 'La sesión ha caducado, inicie sesión de nuevo',
			relogin: 'Iniciar sesión de nuevo'
		},
		validation: {
			email: 'El formato del correo electrónico no es válido',
			passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
			passwordStrength: 'La contraseña debe incluir mayúsculas, minúsculas, números y símbolos',
			mobile: 'El formato del número de móvil no es válido'
		},
		alarmMode: {
			title: 'Cambio de modo de difusión de alarmas',
			placeholder: 'Seleccione el modo de difusión de alarmas',
			none: 'Sin difusión',
			newOnly: 'Difundir alarmas nuevas',
			loop: 'Difusión en bucle'
		},
		ai: {
			deepThinking: 'Razonamiento profundo',
			modelGeneral: 'Modelo de diagnóstico general',
			modelVertical: 'Modelo vertical PHM'
		},
		chart: {
			resetZoom: 'Restablecer',
			drag: 'Arrastrar'
		},
		upload: {
			tip: 'Aviso',
			invalidImageType: '¡El formato de la imagen cargada no es compatible!',
			imageSizeLimit: '¡El tamaño de la imagen no puede superar {size}MB!'
		},
		passwordExpire: {
			title: 'Contraseña caducada',
			message: 'Su contraseña ha caducado (más de 90 días sin actualizarla). Por la seguridad de su cuenta, cámbiela y vuelva a iniciar sesión de inmediato.',
			modifying: 'Modificando...',
			confirm: 'Confirmar cambio'
		},
		routeTitle: {
			device3d: 'Panel digital 3D',
			deviceDetail: 'Detalles del dispositivo',
			factoryDetail: 'Detalles de la fábrica',
			deviceAnnotation: 'Anotación de dispositivo',
			profile: 'Centro personal',
			onlineForm: 'Formulario en línea',
			onlineReport: 'Informe en línea',
			deviceList: 'Lista de dispositivos'
		}
	},
	login: {
		welcome: 'Bienvenido',
		usernamePlaceholder: 'Introduzca el nombre de usuario',
		passwordPlaceholder: 'Introduzca la contraseña',
		remember: 'Recordar usuario y contraseña',
		selectPlatform: 'Seleccione la plataforma a la que desea acceder',
		bindTotp: 'Vincular autenticación de dos factores',
		totp: 'Autenticación de dos factores',
		totpScanStep: 'Paso 1: Escanee el código QR',
		totpScanTip: 'Escanee el código QR a continuación con un autenticador TOTP:',
		totpCodeStep: 'Paso 2: Introduzca el código dinámico',
		totpCodeStepVerify: 'Introduzca el código dinámico',
		totpCodeTip: 'Introduzca el código dinámico de 6 dígitos que muestra su autenticador:',
		totpCodeTipVerify: 'Introduzca su código dinámico de autenticación de dos factores:',
		totpCodePlaceholder: 'Introduzca el código de 6 dígitos',
		verifying: 'Verificando...',
		verifyAndLogin: 'Verificar e iniciar sesión',
		verifyLogin: 'Verificar e iniciar sesión',
		usernamePasswordRequired: 'Introduzca el nombre de usuario y la contraseña',
		accountExpired: 'La cuenta ha caducado, contacte con la persona correspondiente para renovarla',
		totpInitFailed: 'No se pudo inicializar la autenticación de dos factores',
		totpCodeRequired: 'Introduzca el código dinámico de 6 dígitos',
		totpVerifySuccess: 'Autenticación de dos factores verificada correctamente',
		totpCanceled: 'Autenticación de dos factores cancelada, inicie sesión de nuevo',
		passwordChanged: 'Contraseña modificada correctamente, inicie sesión con la nueva contraseña',
		passwordChangeCanceled: 'Modificación de contraseña cancelada',
		imageBase: 'Base',
		imageLine: 'Línea divisoria',
		imageUser: 'Icono de usuario',
		imagePassword: 'Icono de contraseña'
	}
}
